import { create } from "zustand";
import type { Locale, Translations } from "./types";
import { en } from "./locales/en";
import { es } from "./locales/es";

const LOCALE_KEY = "nexo-locale";
const localeMap: Record<Locale, Translations> = { en, es };

function loadLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_KEY) as Locale | null;
    if (stored && localeMap[stored]) return stored;
  } catch {}
  return "en";
}

function saveLocale(locale: Locale) {
  try {
    localStorage.setItem(LOCALE_KEY, locale);
  } catch {}
}

interface I18nState {
  locale: Locale;
  t: Translations;
  setLocale: (locale: Locale) => void;
}

const initialLocale = loadLocale();

export const useI18n = create<I18nState>(set => ({
  locale: initialLocale,
  t: localeMap[initialLocale],
  setLocale: locale => {
    saveLocale(locale);
    set({ locale, t: localeMap[locale] });
  },
}));
